import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=49fa09be&scoped=true"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=49fa09be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa09be",
  null
  
)

export default component.exports